import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router'
import { Element } from '../../../../../../common/html/element'
import { formatText } from '../../../../../../helpers/value'
import { COMPONENTS } from '../../../../../../routers/constants'

export const CompanyName = ({ val, getDataFromRedux, rowId }) => {
  const navigate = useNavigate()

  const organizationId = useSelector(getDataFromRedux(rowId, 'organizationId'))

  const onClick = () => {
    navigate(
      COMPONENTS.companyAnalysis.components.summary.route +
        '?organizationId=' +
        organizationId,
    )
  }

  return (
    <Element
      elementName="span"
      style={{ color: '#2C73E8', cursor: 'pointer' }}
      onClick={onClick}
    >
      {formatText(val)}
    </Element>
  )
}
